import { URLSearchParams } from "@angular/http";
import { Component } from '@angular/core';

@Component({
  selector: 'page-logout',
  templateUrl: 'logout.html'
})
export class LogoutPage {
  usuario: {
    login: string,
    senha: string
  };
  loading: boolean = false;
  ENTER_KEY_CODE = 13;
  loginDoJurisdicionado: boolean = false;

  constructor() {
  }
}




// WEBPACK FOOTER //
// ./src/pages/logout/logout.ts